import React, { Component } from 'react';
import '../../../assets/style/itemStyle/membershipType.scss';
import { divisionNumber, getLocalStorage, openLoginPopup } from '../../../untils/auth';

const ServicesLists = [
  {
    title: '24/7 Global Service Support Team',
    desc: 'Our team is available around the clock to assist you with any inquiries, travel adjustments, or special requirements, ensuring seamless service wherever you are. Travel confidently, knowing that help is just a call away, no matter the hour or time zone.',
    includes: {
      free: true,
      gold: true,
      platinum: true,
    },
  },
  {
    title: 'Last Minute Booking',
    desc: 'On-Demand Services / Short Notice Flights.Need to travel at a moment’s notice? Enjoy priority access to quick departures with flight arrangements confirmed in as little as four hours.',
    includes: {
      free: true,
      gold: true,
      platinum: true,
    },
  },
  {
    title: 'Diverse Fleet Options',
    desc: 'Choose from over 1,000 aircraft, each tailored to different travel needs. Book on light, midsize, super midsize, and heavy jets.',
    includes: {
      free: true,
      gold: true,
      platinum: true,
    },
  },
  {
    title: 'Access to More Than 3,000 Airports Worldwide',
    desc: 'Travel directly to your destination without the limitations of commercial hubs. Our network grants you access to thousands of private airports, allowing you to arrive closer to your final destination, saving time and hassle on ground travel.',
    includes: {
      free: true,
      gold: true,
      platinum: true,
    },
  },
  {
    title: 'Waived Pet Handling Fees',
    desc: 'Your pets are part of the family, and we welcome them onboard without the additional costs of handling fees. Fly with your furry friends worry-free and enjoy our pet-friendly policies as part of your membership benefits.',
    includes: {
      free: 'One Pet',
      gold: 'Unlimited',
      platinum: 'Unlimited',
    },
  },
  {
    title: 'Pet Jet Travel Concierge and Passport',
    desc: 'Take advantage of our Pet Travel Concierge services, which handle all necessary documentation, pet comfort arrangements, and even a unique “Pawsport” for your pet, so you can fly knowing your companion is well cared for.',
    includes: {
      free: true,
      gold: true,
      platinum: true,
    },
  },
  {
    title: 'Additional Benefits and Exclusive Offers',
    desc: 'Enjoy a range of perks and discounts exclusive to members, from luxury hotel partnerships to exclusive offers on charter flights and add-on services. Your membership opens doors to a world of privileges.',

    includes: {
      free: false,
      gold: true,
      platinum: true,
    },
  },
  {
    title: 'Complimentary Aircraft Upgrades (when available)',
    desc: 'Enjoy a premium experience with free aircraft upgrades (when available), ensuring you have the most luxurious and spacious option for your journey without the additional cost.',
    includes: {
      free: false,
      gold: true,
      platinum: true,
    },
  },
  {
    title: 'Additional Discounts for Qualifying Round Trips',
    desc: 'Get more value with every round trip! Save on return flights and make your travel planning even more cost-effective. Qualifying round trips offer additional discounts, making frequent travel more affordable.',
    includes: {
      free: false,
      gold: true,
      platinum: true,
    },
  },
  {
    title: 'Personal Flight Account Manager',
    desc: 'Gain access to your own dedicated account manager, who will be your main point of contact for all flight bookings, preferences, and special requests. It’s personalized service at its finest, tailored to your unique travel needs.',
    includes: {
      free: false,
      gold: true,
      platinum: true,
    },
  },
  {
    title: 'Private Catering Options',
    desc: 'Choose from gourmet menus and customizable catering services for a dining experience that matches your taste and dietary needs. From bespoke meals to seasonal offerings, every meal is a journey in itself.',
    includes: {
      free: 'A la Carte Menu Available',
      gold: 'Complimentary Premium Catering Menu',
      platinum: 'Complimentary Deluxe Menu',
    },
  },
  {
    title: 'Tailored Pet Comfort Packages',
    desc: 'Make travel easier for your pets with customized comfort packages designed to keep them comfortable and entertained throughout the journey.',

    includes: {
      free: false,
      gold: true,
      platinum: true,
    },
  },
  {
    title: 'Luxury Chauffeur Services',
    desc: 'Enjoy seamless transfers with our luxury chauffeur services at both departure and arrival points. Relax in style and arrive at your destination with VIP treatment every step of the way.',
    includes: {
      free: false,
      gold: '12 Free Pickups per Year',
      platinum: '36 Free Pickups per Year',
    },
  },
  {
    title: 'Waived De-Icing Fees',
    desc: 'Travel confidently in colder climates without additional deicing charges. We prioritize safety and comfort, handling the details so you can focus on your journey.',
    includes: {
      free: false,
      gold: true,
      platinum: true,
    },
  },
  {
    title: 'Charter Flight Discounts',
    desc: 'Receive exclusive member discounts on private charter flights to popular destinations, making luxury travel more accessible.',
    includes: {
      free: false,
      gold: '2%',
      platinum: '3%',
    },
  },
];

export default class MembershipType extends Component {
  // 用户登录或游客登录
  goLogin = (data) => {
    this.props.goLogin(data);
  };
  // 登录弹窗
  openLogin = () => {
    //未登录，打开登陆弹窗
    if (!getLocalStorage('token')) {
      return openLoginPopup('open');
    }
  };
  // 定期航班会员弹窗选择会员
  SelectMember = (data) => {
    this.props.switchMember(data);
    this.props.closeDialog();
  };

  render() {
    let { trailData, goldData, platinumData, type } = this.props;
    return (
      <div className="member-type">
        <div className="member-services">
          <b>Services</b>
          {ServicesLists.map((item, index) => (
            <div className="services-box" key={index}>
              <h3>{item.title}</h3>
              <i className="bg-image">
                <p className="fare-seat">{item.desc}</p>
              </i>
            </div>
          ))}
        </div>

        <div className="trial-free">
          <b>Freemium</b>
          {type === 'scheduled' ? null : (
            <button className="free-btn" onClick={() => this.goLogin(trailData)}>
              Get Started
            </button>
          )}
          <ul>
            {ServicesLists.map((item, index) => (
              <li key={index}>
                {typeof item.includes.free === 'string' ? (
                  <b>{item.includes.free}</b>
                ) : item.includes.free ? (
                  <i className="bg-image" />
                ) : (
                  <span />
                )}
              </li>
            ))}
          </ul>
          {type === 'scheduled' ? (
            <button className="free-btn" onClick={() => this.SelectMember('Trial')}>
              Select
            </button>
          ) : null}
        </div>
        <div className="gold-member">
          <div className="title">
            Gold <i className="bg-image"></i>
          </div>
          <div className="total-month">
            <b>${divisionNumber(goldData?.monthlyPrice)}</b>/<span>month</span>{' '}
          </div>
          <div className="total-year">
            ${divisionNumber(goldData?.monthlyPrice * 12)} annual total
          </div>
          <div className="or">- or -</div>
          <div className="total-month">
            <b>${divisionNumber(goldData?.annualPrice)}</b>/<span>year</span>{' '}
          </div>
          <div className="total-year">
            30% discount at ${divisionNumber(goldData?.annualPrice / 12)}/month
          </div>
          {type === 'scheduled' ? null : (
            <button className="gold-btn" onClick={() => this.goLogin(goldData)}>
              Get Started
            </button>
          )}
          <ul>
            {ServicesLists.map((item, index) => (
              <li key={index}>
                {typeof item.includes.gold === 'string' ? (
                  <b>{item.includes.gold}</b>
                ) : item.includes.gold ? (
                  <i className="bg-image" />
                ) : (
                  <span />
                )}
              </li>
            ))}
          </ul>
          {type === 'scheduled' ? (
            <button className="gold-btn" onClick={() => this.SelectMember('Gold')}>
              Select
            </button>
          ) : null}
        </div>
        <div className="platinum-member">
          <div className="title">
            Platinum <i className="bg-image"></i>
          </div>
          <div className="total-month">
            <b>${divisionNumber(platinumData?.monthlyPrice)}</b>/<span>month</span>{' '}
          </div>
          <div className="total-year">
            ${divisionNumber(platinumData?.monthlyPrice * 12)} annual total
          </div>
          <div className="or">- or -</div>
          <div className="total-month">
            <b>${divisionNumber(platinumData?.annualPrice)}</b>/<span>year</span>{' '}
          </div>
          <div className="total-year">
            30% discount at ${divisionNumber(platinumData?.annualPrice / 12)}/month
          </div>
          {type === 'scheduled' ? null : (
            <button className="gold-btn" onClick={() => this.goLogin(platinumData)}>
              Get Started
            </button>
          )}
          <ul>
            {ServicesLists.map((item, index) => (
              <li key={index}>
                {typeof item.includes.platinum === 'string' ? (
                  <b>{item.includes.platinum}</b>
                ) : item.includes.platinum ? (
                  <i className="bg-image" />
                ) : (
                  <span />
                )}
              </li>
            ))}
          </ul>
          {type === 'scheduled' ? (
            <button className="gold-btn" onClick={() => this.SelectMember('Platinum')}>
              Select
            </button>
          ) : null}
        </div>
      </div>
    );
  }
}
